import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import { toast } from "react-toastify";
import CashierAPI from "../../../apis/cashierApi/CashierAPI";
import TableLoader from "../../loaders/TableLoader";
import Pagination from "../../assets/Pagination";

const IndexCompte = () => {

    const [comptes, setComptes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    const fetchComptes = async () => {
        try{
            const data =  await CashierAPI.findComptes();
            setComptes(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes caisse !");
        }
    };



    //Au chargement du composant on va chercher les comptes
    useEffect(() => {
        fetchComptes();
    }, []);


    //Gestion du changement de page
    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 100;

    //Filtrage des comptes en fonction de la recherche

    const filteredComptes = comptes.filter(
        b =>
            b.compte.toLowerCase().includes(search.toLowerCase()) ||
            b.code.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedComptes = Pagination.getData(
        filteredComptes,
        currentPage,
        itemsPerPage
    );

    let numerotation = 1;


    return (
        <>
            <div className="pagetitle">
                <h1>Les comptes caisse</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/cashier">Dashboard</Link></li>
                        <li className="breadcrumb-item active">Les comptes caisse</li>
                    </ol>
                </nav>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-md-7">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <h5 className="card-title">Total {comptes ? comptes.length : 0}</h5>
                                    </div>
                                    <div className="col-6">
                                        <Link className="btn btn-sm btn-primary mt-3 d-block" to="/cashier/comptes/add">
                                            <i className="bi bi-plus-circle"></i> Ajouter un compte caisse
                                        </Link>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <input type="text" onChange={handleSearch} autoComplete="off" value={search} className="form-control" placeholder="Rechercher ..." />
                                </div>
                                <table className="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Nom</th>
                                        <th scope="col">Code</th>
                                        <th scope="col">Options</th>
                                    </tr>
                                    </thead>
                                    {!loading && <tbody>
                                    {paginatedComptes.map((compte) => (
                                            <tr key={compte.id}>
                                                <th scope="row">{numerotation++}</th>
                                                <td>{compte.compte}</td>
                                                <td>{compte.code}</td>
                                                <td>
                                                    <Link className="btn btn-sm btn-outline-primary mx-1" to={`/cashier/comptes/edit/${compte.id}`}>
                                                        <i className="bi bi-pen-fill"></i>
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>}
                                </table>
                                {loading && <TableLoader width={300} height={350} />}

                                {itemsPerPage < filteredComptes.length &&
                                <Pagination
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    length={filteredComptes.length}
                                    onPageChange={handleChangeCurrentPage}
                                />
                                }

                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};

export default IndexCompte;
